import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  PersonioAllowedAttribute,
  PersonioFieldCompact,
  PersonioIntegrationConfig
} from '@dadohr/shared/domainTypes/integrations/personio';
import { CF, FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  callFirebaseFunction,
  useFirebaseFunction
} from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now, ONE_MINUTE } from '../../../../../../services/time';

export const toPersonioConfigDoc = generateToDocFn<PersonioIntegrationConfig>();

const COLLECTION = FS.personioIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const personioConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toPersonioConfigDoc
);

export const usePersonioConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(personioConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<PersonioIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,
            clientId: '',
            clientSecret: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removePersonioConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};

export const getPersonioImportFields = async (orgId: string) => {
  const result = await callFirebaseFunction<PersonioFieldCompact[]>(
    CF.personio.getImportFields,
    { orgId }
  );

  return result;
};

export const getPersonioDestinationFields = async (orgId: string) => {
  const result = await callFirebaseFunction<PersonioAllowedAttribute[]>(
    CF.personio.getDestinationFields,
    { orgId }
  );

  return result;
};

export const usePersonioDestinationFields = (orgId: string) => {
  return useFirebaseFunction<PersonioAllowedAttribute[]>(
    CF.personio.getDestinationFields,
    { orgId },
    [orgId],
    ONE_MINUTE * 15
  );
};
